import { lazy, Suspense } from "react";

type VideoPlayerRivProps = {
  videoName: string;
  width?: string;
  height?: string;
};

const VideoPlayerRivLazy = lazy(() =>
  import("./VideoPlayerRivInner").then((mod) => ({ default: mod.VideoPlayerRivInner })),
);

export const VideoPlayerRiv: React.FC<VideoPlayerRivProps> = (props) => {
  return (
    <Suspense fallback={null}>
      <VideoPlayerRivLazy {...props} />
    </Suspense>
  );
};
